import 'normalize.css/normalize.css';
import './fonts/ciutadella.css';
import './polyfills';
import './console';

import React from 'react';
import { render, hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider } from 'roo-ui';
import Cookies from 'universal-cookie';
import { loadableReady } from '@loadable/component';
import ReactModal from 'react-modal';
import { HelmetProvider } from 'react-helmet-async';
import createStore from './store/createStore';
import App from './components/App';
import theme from './lib/theme';
import hydrationComplete from './lib/initialDispatch/hydrationComplete';
import './sentry';
import { QffAuthEventSubscriber } from './components/User';
import CampaignFetcher from './components/CampaignFetcher';
import { GTM_ID } from './config';
import gtmInitialise from './lib/analytics/gtmInitialise';
import createBrowserSplitClient from './lib/split/createBrowserSplitClient';
import findQhUserId from './lib/findQhUserId';
import { initializeSplit } from './lib/split/initializeSplit';
import SentryContextHelper from './components/SentryContextHelper';
const cookies = new Cookies();
const qhUserId = findQhUserId(cookies);

// GTM is loaded client side, before the redux store is created
if (GTM_ID) gtmInitialise({ gtmId: GTM_ID, dataLayer: { qh_user_id: qhUserId } });

const splitClient = createBrowserSplitClient({ id: qhUserId });

const { store, history } = createStore({ splitClient, cookies });

initializeSplit(store);

const application = (AppComponent) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <AppComponent>
            <QffAuthEventSubscriber />
            <CampaignFetcher />
            <SentryContextHelper />
          </AppComponent>
        </ThemeProvider>
      </HelmetProvider>
    </ConnectedRouter>
  </Provider>
);

const root = document.getElementById('root');
ReactModal.setAppElement(root);

loadableReady(() => {
  hydrate(application(App), root);
  hydrationComplete();
});

// Hot module reloading for CRA (retains redux state, but not local component state)
if (module.hot) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default; // eslint-disable-line global-require
    render(application(NextApp), root);
  });
}
